import React from 'react';
import { type UiConfigType, embedDashboard } from '@superset-ui/embedded-sdk';
import { SUPERSET_AUTHENTICATION, SUPERSET_DOMAIN } from '../../config';

async function fetchGuestToken(id: string) {
  const response = await fetch(SUPERSET_AUTHENTICATION, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ dashboard_id: id }),
  });

  const data: { token: string } = await response.json();

  return data.token;
}

type DashboardProps = {
  id: string;
  dashboardUiConfig?: UiConfigType;
};

export function Dashboard(props: DashboardProps) {
  const { id, dashboardUiConfig } = props;
  const ref = React.useRef<HTMLDivElement | null>(null);

  React.useEffect(() => {
    async function run() {
      if (ref.current) {
        await embedDashboard({
          id,
          supersetDomain: SUPERSET_DOMAIN,
          mountPoint: ref.current,
          fetchGuestToken: () => fetchGuestToken(id),
          dashboardUiConfig,
        });
      }
    }

    run();
  }, [id, dashboardUiConfig]);

  return <div ref={ref} className='embed-container' />;
}
